import { createFeatureSelector, createSelector } from '@ngrx/store';
import { BusinessSettingState } from '@store/reducers';

export const selectBusinessSettingSuggestionState = createFeatureSelector<BusinessSettingState>('businessSetting');

export const selectBusinessSettingLoading = createSelector(
  selectBusinessSettingSuggestionState,
  (state: BusinessSettingState) => state.loading
);

export const selectBusinessSettingEditMode = createSelector(
  selectBusinessSettingSuggestionState,
  (state: BusinessSettingState) => state.editMode
);

export const selectBusinessSettingIsEditing = createSelector(
  selectBusinessSettingSuggestionState,
  (state: BusinessSettingState) => state.isEditing
);

export const selectBusinessSettingId = createSelector(
  selectBusinessSettingSuggestionState,
  (state: BusinessSettingState) => state.businessSettingId
);

export const selectBusinessSetting = createSelector(
  selectBusinessSettingSuggestionState,
  (state: BusinessSettingState) => state.businessSetting
);

export const selectBusinessSettingList = createSelector(
  selectBusinessSettingSuggestionState,
  (state: BusinessSettingState) => state.businessSettingList
);

export const selectBusinessSettingForm = createSelector(
  selectBusinessSettingSuggestionState,
  (state: BusinessSettingState) => state.businessSettingForm
);

export const selectBusinessSettingError = createSelector(
  selectBusinessSettingSuggestionState,
  (state: BusinessSettingState) => state.error
);

export const selectBusinessSettingValidForm = createSelector(
  selectBusinessSettingSuggestionState,
  (state: BusinessSettingState) => state.validForm
);